export const authorizedAccounts = [
    {
        email: "admin@teambox.dev",
        password: "admin1234",
    },
];